// Sometime happens in mobile browsers
// (reproduced in Safari in responsive mode on MacOs)
// when app follow user to external page (e.g. during MFA switching or social login)
// and user press browser back button on that page
// the page is not reloaded and app freeze in previous state
// How to use:
// have $_browserBackButton_fallback method in component
// before redirecting user to external page call $_browserBackButton_setFallback
// after user return to app call $_browserBackButton_removeFallback to remove listener

export default {
  methods: {
    $_browserBackButton_action() {
      if (typeof this.$_browserBackButton_fallback === 'function') {
        this.$nextTick(this.$_browserBackButton_fallback);
      }
    },
    $_browserBackButton_setFallback() {
      window.addEventListener('pageshow', this.$_browserBackButton_onBrowserPageShow);
    },
    $_browserBackButton_removeFallback() {
      window.removeEventListener('pageshow', this.$_browserBackButton_onBrowserPageShow);
    },
    $_browserBackButton_onBrowserPageShow() {
      if (this._isDestroyed) {
        this.removeBrowserBackButtonFallback();
        return;
      }
      const perfEntries = performance.getEntriesByType('navigation');
      if (perfEntries.length) {
        const { type } = perfEntries[0];
        if (['back_forward', 'reload', 'navigation'].includes(type)) this.$_browserBackButton_action();
      } else if (performance?.navigation?.type === 2) {
        this.$_browserBackButton_action();
      }
    },
  },
};
